module.exports = __webpack_public_path__ + "img/base_divers_tel_fixe.a2534868.svg";